import { useQuery } from "@hooks/useQuery";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useNotification } from "~/Hooks/useNotification";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { fields } from "../../constants";
import { useRestrictedItemsSections } from "../../Pages.hook";

export const RestrictedItemsSections = () => {
  const { openToast } = useNotification();
  const query = useQuery();
  const navigate = useNavigate();
  const fourthChildActiveTab = query.get("fourthChildActiveTab");

  const {
    data: singleCabinLuggagePolicy,
    isLoading: isLoadingSingleCabinLuggagePolicy,
    refetch: refetchsingleCabinLuggagePolicy,
  } = useRestrictedItemsSections();
  const {
    data: travellersInfoById,
    isLoading: isLoadingTravellersInfoById,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    } else {
      refetchsingleCabinLuggagePolicy();
    }
  }, [query.get("id")]);

  const singleCabinLuggagePolicyFormConfig: FormConfig = {
    initialValues: {
      tab_title_english: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.tab_title_english)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0].tab_title_english)
          : "",
      tab_title_malay: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.tab_title_malay)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0].tab_title_malay)
          : "",
      tab_title_mandarin: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.tab_title_mandarin)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0].tab_title_mandarin)
          : "",
      english_title: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.english_title)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.english_title)
          : "",
      malay_title: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.malay_title)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0].malay_title)
          : "",
      mandarin_title: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.mandarin_title)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.mandarin_title)
          : "",
      english_title_2: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.english_title_2)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.english_title_2)
          : "",
      malay_title_2: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.malay_title_2)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0].malay_title_2)
          : "",
      mandarin_title_2: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.mandarin_title_2)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.mandarin_title_2)
          : "",
      english_title_3: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.english_title_3)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.english_title_3)
          : "",
      malay_title_3: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.malay_title_3)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0].malay_title_3)
          : "",
      mandarin_title_3: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.mandarin_title_3)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.mandarin_title_3)
          : "",
    },
    fields:
      fourthChildActiveTab === "restrictedItemsCheckedInCabinRestrictionsContent"
        ? fields.restrictedItemsCheckedInCabinRestrictionsContent
        : fields.restrictedItemsCabinOnlyRestrictionsContent,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }
    const payload = {
      action: action,
      method: method,
      module: "Pages",
      subModule: `travellersInfo_lagsAndRestrictedItems_restrictedItems_${query.get("fourthChildActiveTab")}`,
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...data,
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <div>
      <DynamicForm
        isLoading={isLoadingSingleCabinLuggagePolicy || isLoadingTravellersInfoById}
        config={singleCabinLuggagePolicyFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${eramanHost}/api/restricted/item/section-one/${singleCabinLuggagePolicy?.[0]?.nid || travellersInfoById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </div>
  );
};
